export default {
    name: 'PasswordManager',
    version: '1.0.2'
}
